<template>
  <login-wrapper>
    <detail-wrapper chamber="senate"></detail-wrapper>
  </login-wrapper>
</template>

<script>
import { DetailWrapper } from '@/components'
import { LoginWrapper } from '@/components/common'

const name = 'senate'

const components = {
  DetailWrapper,
  LoginWrapper
}

export default {
  name,
  components,
  metaInfo: {
    title: '2020 Senate Forecast'
  }
}
</script>
